import React, { useCallback, useState } from "react";
import ContactSection from "@/components/sections/ContactSection";
import Footer from "@/components/sections/Footer";
import HeroSection from "@/components/sections/HeroSection";
import Navbar from "@/components/sections/Navbar";
import PropuestaValorSection from "@/components/sections/PropuestaValorSection";
import ServicesSection from "@/components/sections/ServicesSection";
import TeamSection from "@/components/sections/TeamSection";
import ReadingProgress from "@/components/ui/ReadingProgress";
import WhatsAppButton from "@/components/ui/WhatsAppButton";
import { COLORS, FONTS } from "@/constants/theme";

/**
 * Ensamble de secciones de la landing pública.
 *
 * Guarda aquí los servicios que el visitante marca en la sección de servicios,
 * porque los consume el formulario de contacto: es el único estado que dos
 * secciones hermanas necesitan compartir.
 *
 * @returns {JSX.Element}
 */
const LandingPage = () => {
  const [serviciosElegidos, setServiciosElegidos] = useState([]);

  const alternarServicio = useCallback((titulo) => {
    setServiciosElegidos((previos) =>
      previos.includes(titulo) ? previos.filter((t) => t !== titulo) : [...previos, titulo],
    );
  }, []);

  return (
    <div
      style={{
        backgroundColor: COLORS.lightSection,
        color: COLORS.lightText,
        fontFamily: FONTS.body,
      }}
    >
      <ReadingProgress />
      <Navbar />
      <main>
        <HeroSection />
        <PropuestaValorSection />
        <ServicesSection onAlternarServicio={alternarServicio} serviciosElegidos={serviciosElegidos} />
        <TeamSection />
        <ContactSection onQuitarServicio={alternarServicio} serviciosElegidos={serviciosElegidos} />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default LandingPage;
